import * as z from "zod";

const metafieldValueSchema = z.object({
  /** The full metafield key in "namespace.key" format */
  key: z.string(),
  value: z.string().nullable(),
});

export const getProductVariantMetafields = {
  name: "getProductVariantMetafields" as const,
  input: z.object({
    productId: z.string(),
    variantId: z.string(),
    /** Metafield keys in "namespace.key" format */
    productMetafields: z.array(z.string()),
    variantMetafields: z.array(z.string()),
  }),
  output: z.object({
    productMetafields: z.array(metafieldValueSchema),
    variantMetafields: z.array(metafieldValueSchema),
  }),
};
